module.exports = __webpack_public_path__ + "static/media/faveats-main.42728412.png";